import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import BuddyBot from './BuddyBot';

export default function AskBuddy() {
  const [chatHistory, setChatHistory] = useState([]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-purple-50 flex flex-col items-center justify-start pt-8 px-4">
        <h1 className="text-3xl font-bold text-purple-800 mb-4">🤖 Talk to Buddy</h1>
        <div className="w-full max-w-2xl bg-white shadow-lg rounded-xl p-4">
          <BuddyBot history={chatHistory} setHistory={setChatHistory} />
        </div>
      </div>
    </>
  );
}